import config from "@/config";
var varsArray = [
    {
        fromHtmlAttr: "data-ui-env",
        toGlobalVar: "UI_ENV",
    },
];
var reactRoot = document.getElementById("app");
if (reactRoot) {
    varsArray.forEach(function (varObj) {
        var variable = reactRoot.getAttribute(varObj.fromHtmlAttr);
        if (variable) {
            window[varObj.toGlobalVar] = variable;
        }
    });
}
export var cookieConfig = {
    domain: config.domain,
    path: "/",
    sameSite: (config.domain === "localhost" || config.domain === "staging"
        ? false
        : "none"),
    secure: config.domain === "localhost" || config.domain === "staging" ? false : true,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmFyaWFibGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidmFyaWFibGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sTUFBTSxNQUFNLFVBQVUsQ0FBQztBQUU5QixJQUFNLFNBQVMsR0FBRztJQUNoQjtRQUNFLFlBQVksRUFBRSxhQUFhO1FBQzNCLFdBQVcsRUFBRSxRQUFRO0tBQ3RCO0NBQ0YsQ0FBQztBQUVGLElBQU0sU0FBUyxHQUFHLFFBQVEsQ0FBQyxjQUFjLENBQUMsS0FBSyxDQUFDLENBQUM7QUFDakQsSUFBSSxTQUFTLEVBQUU7SUFDYixTQUFTLENBQUMsT0FBTyxDQUFDLFVBQUMsTUFBTTtRQUN2QixJQUFNLFFBQVEsR0FBRyxTQUFTLENBQUMsWUFBWSxDQUFDLE1BQU0sQ0FBQyxZQUFZLENBQUMsQ0FBQztRQUM3RCxJQUFJLFFBQVEsRUFBRTtZQUNaLE1BQU0sQ0FBQyxNQUFNLENBQUMsV0FBVyxDQUFDLEdBQUcsUUFBUSxDQUFDO1NBQ3ZDO0lBQ0gsQ0FBQyxDQUFDLENBQUM7Q0FDSjtBQUVELE1BQU0sQ0FBQyxJQUFNLFlBQVksR0FBRztJQUMxQixNQUFNLEVBQUUsTUFBTSxDQUFDLE1BQU07SUFDckIsSUFBSSxFQUFFLEdBQUc7SUFDVCxRQUFRLEVBQUUsQ0FBQyxNQUFNLENBQUMsTUFBTSxLQUFLLFdBQVcsSUFBSSxNQUFNLENBQUMsTUFBTSxLQUFLLFNBQVM7UUFDckUsQ0FBQyxDQUFDLEtBQUs7UUFDUCxDQUFDLENBQUMsTUFBTSxDQUEwQztJQUNwRCxNQUFNLEVBQ0osTUFBTSxDQUFDLE1BQU0sS0FBSyxXQUFXLElBQUksTUFBTSxDQUFDLE1BQU0sS0FBSyxTQUFTLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsSUFBSTtDQUM5RSxDQUFDIn0=